import { render } from "./EDA.vue?vue&type=template&id=021abb06&scoped=true&ts=true"
import script from "./EDA.vue?vue&type=script&lang=ts"
export * from "./EDA.vue?vue&type=script&lang=ts"

import "./EDA.vue?vue&type=style&index=0&id=021abb06&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021abb06"]])

export default __exports__